import { render, staticRenderFns } from "./DsnButtonEdit.vue?vue&type=template&id=5f315da8&"
import script from "./DsnButtonEdit.vue?vue&type=script&lang=js&"
export * from "./DsnButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports